<template>
	<div>
		<v-dialog v-model="dialog_page_margin" v-if="dialog_page_margin" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
				<v-card-title class="title noshadow">
					Page {{ type }} Margin
				</v-card-title>
        	  	<v-card-text>
        	  		<v-form>
						  <v-text-field
                            type="number"
        	  			    :placeholder="'Enter ' + type + ' Margin'"
        	  			    v-model="margin"
                            :hide-details="true"
        	  			></v-text-field>
                        <div right-align light-opacity-color class="mb-3">px</div>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="closeDialogWeb">cancel</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_changeMargin">Done</v-btn>
		        </v-card-actions>
	        	</v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	props:['type'],
	data(){	
		return{
			dialog_page_margin: false,
			margin:null
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.margin = null;
			this.$nextTick(() => {
				if(this.type == 'Top'){
					if(this.$parent.$refs['ref_previewTemplate'].invoiceFieldsObj.pageTopMargin.value){
						this.margin = this.$parent.$refs['ref_previewTemplate'].invoiceFieldsObj.pageTopMargin.value;
					}
				}
				else if(this.type == 'Bottom'){
					if(this.$parent.$refs['ref_previewTemplate'].invoiceFieldsObj.pageBottomMargin.value){
						this.margin = this.$parent.$refs['ref_previewTemplate'].invoiceFieldsObj.pageBottomMargin.value;
					}
				}
				this.dialog_page_margin = true;
			})
		},
		closeDialogWeb: function () {
			this.dialog_page_margin = false;
		},
        fn_changeMargin: function(){
            if(this.margin < 0){
                this.showToast('Enter valid margin');
            }
            else{
                this.$parent.fn_changePageMargin(this.margin);
            }
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/invoice_templates/dialogs/dialog_page_margin.vue